const LIVE_CHANNEL_INITIAL_STATE = {
	liveChannels: [],
	liveStreams: [],
	liveCategories: [],
	liveStreamScrollOffset: 0,
	totalStreams: -1,
};

export default LIVE_CHANNEL_INITIAL_STATE;
